export default __webpack_public_path__ + "static/media/REACT_ico.73880b5d.svg";